import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Flag.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: m }));
a.displayName = "FlagIcon";
const n = a;
export {
  n as Flag,
  a as FlagIcon
};
